import type {TraversalSnapshot} from '../node-traversal/traversal-snapshot'
import type {BlockOffset} from '../types/block-offset'
import type {EditorSelection} from '../types/editor'
import {blockOffsetToSelectionPoint} from './util.block-offset-to-selection-point'

/**
 * @public
 */
export function blockOffsetsToSelection({
  snapshot,
  offsets,
  backward,
}: {
  snapshot: TraversalSnapshot
  offsets: {anchor: BlockOffset; focus: BlockOffset}
  backward?: boolean
}): EditorSelection {
  const anchor = blockOffsetToSelectionPoint({
    snapshot,
    blockOffset: offsets.anchor,
    direction: backward ? 'backward' : 'forward',
  })
  const focus = blockOffsetToSelectionPoint({
    snapshot,
    blockOffset: offsets.focus,
    direction: backward ? 'forward' : 'backward',
  })

  if (!anchor || !focus) {
    return null
  }

  return {
    anchor,
    focus,
    backward,
  }
}
